document.addEventListener('DOMContentLoaded', function() {
    // Get the menu button and menu elements
    const menuButton = document.querySelector('.site-header__main-menu-toggle button');
    const mobileMenu = document.querySelector('.site-header__mobile-menu');

    menuButton.addEventListener('click', function() {
        // Toggle aria-expanded attribute
        let isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);

        // Toggle menu visibility
        if (isExpanded) {
            // Close menu
            mobileMenu.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('menu-opened');
            document.body.style.overflow = 'auto'; // Enable scrolling
        } else {
            // Open menu
            mobileMenu.setAttribute('aria-hidden', 'false');
            document.body.classList.add('menu-opened');
            document.body.style.overflow = 'hidden'; // Disable scrolling when menu is open
        }
    });
});

// fix conflict between seach field from mega-menu and tribe_event plugin
document.addEventListener("DOMContentLoaded", function() {
    var searchForm = document.querySelector(".mega-search-wrap form"); // Selects the mega menu search form

    if (searchForm) {
        searchForm.addEventListener("submit", function(event) {
            var searchInput = searchForm.querySelector('input[name="s"]');
            var searchQuery = searchInput ? searchInput.value.trim() : "";

            if (searchQuery.length > 0) {
                event.preventDefault(); // Prevents any unintended behavior
                window.location.href = searchForm.action + "?s=" + encodeURIComponent(searchQuery);
            }
        });

        // Ensure Enter key submits the form correctly
        var searchInput = searchForm.querySelector('input[name="s"]');
        if (searchInput) {
            searchInput.addEventListener("keydown", function(event) {
                if (event.key === "Enter") {
                    event.preventDefault(); // Stop any unwanted behavior
                    searchForm.submit(); // Manually submit the form
                }
            });
        }
    }
});

// ESC key: return focus one level up — from inside a sub-menu panel to the top-level trigger link.
document.addEventListener("DOMContentLoaded", function() {
    var mainMenu = document.querySelector('.site-header__main-menu');
    if (!mainMenu) return;

    mainMenu.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;

        var topLevelItems = mainMenu.querySelectorAll('.mega-menu > li.mega-menu-item.mega-menu-item-has-children');

        topLevelItems.forEach(function(item) {
            var subMenu = item.querySelector(':scope > .mega-sub-menu');
            if (!subMenu || !subMenu.contains(document.activeElement)) return;

            var triggerLink = item.querySelector(':scope > a.mega-menu-link');
            if (!triggerLink) return;

            event.preventDefault();

            // Hide panel visually and remove all sub-menu links from tab order
            // so Tab from the trigger goes to the next top-level item, not back into the panel
            item.classList.add('mega-menu-item--esc-closed');
            item.classList.remove('mega-menu-item--expanded');

            var subMenuLinks = subMenu.querySelectorAll('a, button, [tabindex]');
            subMenuLinks.forEach(function(el) {
                el.setAttribute('tabindex', '-1');
            });

            triggerLink.focus();

            // Restore everything once focus truly leaves this menu item
            function handleFocusOut(e) {
                if (!item.contains(e.relatedTarget)) {
                    item.classList.remove('mega-menu-item--esc-closed');
                    subMenuLinks.forEach(function(el) {
                        el.removeAttribute('tabindex');
                    });
                    item.removeEventListener('focusout', handleFocusOut);
                }
            }
            item.addEventListener('focusout', handleFocusOut);
        });
    });
});

// Desktop megamenu: keyboard navigation fallback for browsers without :has() support.
// Roll animation is CSS clip-path only — no JS height manipulation needed.
document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth < 1025) return;

    var menuItems = document.querySelectorAll('.site-header__main-menu .mega-menu > li.mega-menu-item.mega-menu-item-has-children');

    menuItems.forEach(function(item) {
        var triggerLink = item.querySelector(':scope > a.mega-menu-link');
        if (!triggerLink) return;

        var ariaObserver = new MutationObserver(function() {
            var isExpanded = triggerLink.getAttribute('aria-expanded') === 'true';
            item.classList.toggle('mega-menu-item--expanded', isExpanded);
        });
        ariaObserver.observe(triggerLink, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
});
